import { set, toggle } from '@/utils/vuex';
import AlertType from '@/utils/alertType';

export default {  
  setType: set('type'),
  setAlertMessage: (state, {messages, alert, callback }) => {    
    state.message = typeof(messages) === "string" ? [messages] : messages;    
    state.isConfirmDialog = false;
    state.fnCallback = callback;
    state.type = alert || AlertType.ALERTA;
    state.show = true;
  },
  setServerWarning: (state, payload) => {
    state.message = typeof(payload) === "string" ? [payload] : payload;    
    state.isConfirmDialog = false;    
    state.type = AlertType.ALERTA;
    state.show = true;
  },
  setServerError: (state, payload) => {
    state.message = typeof(payload) === "string" ? [payload] : payload;    
    state.isConfirmDialog = false;
    state.type = AlertType.ERRO;
    state.show = true;
  },  
  setConfirmMessage: (state, { message, yes, no, type }) => {      
    state.message = typeof(message) === "string" ? [message] : message;
    state.isConfirmDialog = true;
    state.fnCallback = yes;
    state.fnCallbackNo = no;    
    state.type = type || AlertType.INFO;
    state.show = true;
  },  
  setCallback: (state, payload) => {
    state.fnCallback = payload;
    state.fnCallbackNo = payload;
  },
  toggleShow: toggle('show'),  
}